document.addEventListener('DOMContentLoaded', () => {
  const productCards = document.querySelectorAll('[data-mobile-image-swap]');

  productCards.forEach((card) => {
    let tappedOnce = false;
    let touchStartY = 0;
    let touchMoved = false;

    card.addEventListener('touchstart', (e) => {
      touchMoved = false;
      touchStartY = e.touches[0].clientY;
    });

    card.addEventListener('touchmove', (e) => {
      const currentY = e.touches[0].clientY;
      if (Math.abs(currentY - touchStartY) > 10) {
        touchMoved = true; // it's a scroll gesture, not a tap
      }
    });

    card.addEventListener('touchend', (e) => {
      // Only trigger swap if user didn’t scroll
      if (!touchMoved && card.dataset.hasSecondary === 'true') {
        if (!tappedOnce) {
          // First tap → show secondary image
          card.classList.add('is-mobile-swapped');
          tappedOnce = true;

          // Reset tap state after 2 seconds so scrolling feels natural
          setTimeout(() => (tappedOnce = false), 2000);

          // Prevent link navigation
          e.preventDefault();
        } else {
          // Second tap within 2s → go to product page
          const productLink = card.querySelector('a');
          if (productLink) {
            window.location.href = productLink.href;
          }
        }
      }
    });
  });
});



